import { createContext } from 'react';
import { type DealerListDataFragment } from '../../../api/fragments/DealerListData';

type DealersState = {
    id: string;
    isSingle: boolean;
    isMultiple: boolean;
    visible: boolean;
};

export type DealerOption = {
    label: string;
    value: string;
};

export type DealerContextData = {
    dealers?: DealersState[];
    setDealers: (newDealerState: DealersState[]) => void;
    dealerOptions: DealerOption[];
    setDealerOptions: (newDealerOptions: DealerOption[]) => void;
    dealersFromApi: DealerListDataFragment[];
    dealerIdsByCompanyId: (companyId: string) => string[];
    displayDropdown?: boolean;
    setDisplayDropdown?: (displayDropdown: boolean) => void;
    setVisible?: (dealerIds: string[], visible: boolean) => void;
    setAllVisible?: () => void;
};

export const DealerContext = createContext<DealerContextData | null>(null);
